(() => {
  if (window.surfaceUnscriptedReady) return;
  window.surfaceUnscriptedReady = true;

  const animations = new WeakMap();

  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('[data-podcast-play]');
    if (playButton) {
      const videoId = playButton.dataset.youtubeId;
      if (!/^[\w-]{11}$/.test(videoId || '')) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
      iframe.title = playButton.getAttribute('aria-label') || 'Watch podcast episode on YouTube';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      playButton.replaceWith(iframe);
      return;
    }

    const toggle = event.target.closest('.surface-podcast-platforms__more');
    if (!toggle) return;

    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!content) return;

    const expanding = toggle.getAttribute('aria-expanded') !== 'true';
    const running = animations.get(content);
    const startHeight = content.hidden ? 0 : content.getBoundingClientRect().height;
    if (running) running.cancel();

    toggle.setAttribute('aria-expanded', String(expanding));
    if (expanding) content.hidden = false;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      content.hidden = !expanding;
      return;
    }

    const animation = content.animate([
      { height: `${startHeight}px`, opacity: expanding ? 0 : 1, overflow: 'hidden' },
      { height: `${expanding ? content.scrollHeight : 0}px`, opacity: expanding ? 1 : 0, overflow: 'hidden' }
    ], { duration: 240, easing: 'ease-in-out' });

    animations.set(content, animation);
    animation.onfinish = () => {
      if (!expanding) content.hidden = true;
      animations.delete(content);
    };
  });
})();
